<!-- HTML -->
<div class="calendar-container">

  <!-- Calendar Header -->
  <header class="calendar-header">
    <div class="button-group">
      <aecom-button
        innerClass="btn-icon blue solid"
        (click)="goToday()"
        >Today - {{ today | date:'MM/dd' }}</aecom-button
        >
        <button style="margin-left: 10px;" class="previous-button" (click)="goPrev()">
          <em style="width: 30px; height: 30px;" class="icon icon-blue" [ngClass]="'icon-action_arrow_left'"></em>
        </button>
        <button style="margin-left: 0px;" class="next-button" (click)="goNext()">
          <em style="width: 30px; height: 30px" class="icon icon-blue" [ngClass]="'icon-action_arrow_right'"></em>
        </button>
        @switch (view) {
          @case (CalendarView.Month) {
            <h1 class="month-label">{{ selectedMonth | date:'MMMM yyyy' }}</h1>
          }
          @case (CalendarView.Week) {
            <h1 class="month-label">{{ weeklyStartDate | date:'MMM dd yyyy' }} - {{ weeklyEndDate | date:'MMM dd yyyy' }}</h1>
          }
        }
        <aecom-date
          [weekendsOff]="true"
          [theme]="'light'"
          [ngValue]="getPickerDate()"
          (change)="onPickerChange($event)"
          style="padding-left: 50px;"
        ></aecom-date>
      </div>
      <div class="button-group view-buttons">
        <!-- <aecom-dropdown
        style="z-index: 1000; width: 220px; padding-right: 10px;"
        [theme]="'light'"
        [data]="calendarSelect"
        placeholder="Select Calendar"
        [multipleSelect]="false"
        [selectedId]="selectedCalendarId"
        (ngValueChange)="changeCalendar($event)"
        [disabled]="isLoading ? true : null"
      ></aecom-dropdown> -->
      <!-- AECOM date picker that works for both Month and Week views -->

      <aecom-textbox
        class="calendar-search"
        [theme]="'light'"
        placeholder="Search"
        iconRight="icon-basic_magnifier"
        [(ngValue)]="searchInput"
        (keyupEnter)="applySearch()"
        (iconRightClick)="applySearch()"
      ></aecom-textbox>
      <aecom-dropdown
        [hidden]="
          facilityCode().includes('Manhattan') ||
          facilityCode().includes('Brooklyn')  ||
          facilityCode().includes('Queens')    ||
          facilityCode().includes('Bronx')
        "
        style="z-index: 1000; width: 300px; padding-right: 10px;"
        [theme]="'light'"
        [data]="boroughFilter"
        placeholder="Borough(s)"
        [multipleSelect]="true"
        (ngValueChange)="changeBoroughFilter($event)"
        [disabled]="isLoading ? true : null"
      ></aecom-dropdown>
      <aecom-dropdown
        style="z-index: 1000; width: 140px;"
        [theme]="'light'"
        [data]="viewSelect"
        [selectedId]="view"
        (ngValueChange)="changeView($event)"
        [disabled]="isLoading ? true : null"
      ></aecom-dropdown>
      @if (canExport) {
        <aecom-button
          style="margin-left: 10px; flex-shrink: 0;"
          innerClass="btn-icon blue solid"
          [disabled]="isLoading ? true : null"
          (click)="exportCsv()"
          >Export</aecom-button
        >
      }
      <!-- <button class="nav-button" [disabled]="isLoading ? true : null" [ngClass]="{ 'selected': view===CalendarView.Month }" (click)="!isLoading && viewMonth()">Month</button> -->
      <!-- <button class="nav-button" [disabled]="isLoading ? true : null" [ngClass]="{ 'selected': view===CalendarView.Week }" (click)="!isLoading && viewWeek()">Work Week</button> -->
      <!-- <button class="nav-button" (click)="viewDay()">Day</button> -->
    </div>
  </header>

  @if (isSearchMode) {
    <div class="search-keyword-bar">
      <span class="keyword-chip">
        {{ searchKeyword }}
        <button class="keyword-clear" title="Clear search" (click)="clearSearch()">&times;</button>
      </span>
    </div>
  }

  <!-- Loading Indicator -->
  @if (isLoading) {
    <div class="loading">Loading...</div>
  }

  @if (!isLoading) {
    <div class="loaded">
      <!-- Tooltip outside of .events -->
      <div
        class="event-tooltip"
        [ngClass]="{ 'visible': tooltipVisible }"
        [ngStyle]="{ top: tooltipPosition.y + 'px', left: tooltipPosition.x + 'px' }"
        >
        <span class="event-time">
          {{ hoveredEvent?.startMultipleDays || hoveredEvent?.start | date: 'M/d/yyyy' }}
          {{ hoveredEvent?.startMultipleDays || hoveredEvent?.start | date: 'shortTime' }} -
          {{ hoveredEvent?.endMultipleDays   || hoveredEvent?.end   | date: 'M/d/yyyy' }}
          {{ hoveredEvent?.endMultipleDays   || hoveredEvent?.end   | date: 'shortTime' }}
        </span>
        <span class="event-subject">{{ hoveredEvent?.subject }}</span>
      </div>
      <div class="calendar-grid" >
        @if (isSearchMode) {
          <div class="search-results">
            <table>
              <thead>
                <tr>
                  <th>Subject</th>
                  <th>Start</th>
                  <th>End</th>
                </tr>
              </thead>
              <tbody>
                @for (event of visibleSearchResults; track $index) {
                  <tr (click)="showEventDetails(event)">
                    <td>{{ event.subject }}</td>
                    <td>{{ formatListStart(event) }}</td>
                    <td>{{ formatListEnd(event) }}</td>
                  </tr>
                } @empty {
                  <tr class="no-results">
                    <td colspan="3">No events found</td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        } @else {
        @switch (view) {
          @case (CalendarView.Month) {
            <app-calendar-monthly-view
              class="flexBox"
              [calendars]="calendars"
              [selectedMonth]="selectedMonth"
              (eventClick)="showEventDetails($event)"
              (eventMouseOver)="showTooltip($event.event, $event.mouse)"
              (eventMouseLeave)="hideTooltip()">
            </app-calendar-monthly-view>
          }
          @case (CalendarView.Week) {
            <app-calendar-weekly-view
              class="flexBox"
              [calendars]="calendars"
              [startDate]="weeklyStartDate"
              (eventClick)="showEventDetails($event)"
              (eventMouseOver)="showTooltip($event.event, $event.mouse)"
              (eventMouseLeave)="hideTooltip()">
            </app-calendar-weekly-view>
          }
        }
        }
      </div>
    </div>
  }
</div>
